import React, { Component } from "react";
import { ERROR_FOCUS_ATTRIBUTE, FormSubscriber } from "../Form/Form";
import uid from "assets/scripts/utils/uid";
import createRef from "assets/scripts/utils/createRef";
import includeHelpId from "./includeHelpId";
function shouldShowError(props, state) {
    const { formState } = props;
    if (props.error != null
        && (!state.focused || !state.suppressErrorWhenFocused)
        && (state.touched === formState.version || formState.failedSubmit != null)) {
        return true;
    }
    if (props.backendError != null) {
        return true;
    }
    return false;
}
class InnerFormGroupContainer extends Component {
    constructor(props, context) {
        super(props, context);
        this._uid = uid();
        this.state = {
            touched: -1,
            focused: false,
            suppressErrorWhenFocused: false,
            failedSubmit: props.formState.failedSubmit
        };
        this._handleChange = this._handleChange.bind(this);
        this._handleFocus = this._handleFocus.bind(this);
        this._handleBlur = this._handleBlur.bind(this);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        let { suppressErrorWhenFocused } = prevState;
        if (prevState.focused) {
            if (!prevState.suppressErrorWhenFocused
                && !shouldShowError(nextProps, prevState)) {
                // gone from error to valid while focused, turn error suppression back on
                // so no new errors show up until a blur again
                suppressErrorWhenFocused = true;
            }
            else if (prevState.suppressErrorWhenFocused
                && nextProps.formState.failedSubmit != null
                && nextProps.formState.failedSubmit !== prevState.failedSubmit) {
                // form submitted and failed while focused (i.e. enter key), turn off error suppression
                suppressErrorWhenFocused = false;
            }
        }
        if (suppressErrorWhenFocused !== prevState.suppressErrorWhenFocused
            || prevState.failedSubmit !== nextProps.formState.failedSubmit) {
            return {
                suppressErrorWhenFocused,
                failedSubmit: nextProps.formState.failedSubmit,
            };
        }
        return null;
    }
    render() {
        const { props } = this;
        const showHelp = includeHelpId(props);
        const showError = shouldShowError(props, this.state);
        const id = props.id || `form-control-${this._uid}`;
        const helpId = showHelp ? `${id}-help` : null;
        const errorId = showError ? `${id}-error` : null;
        const attrs = {
            id,
            name: props.name,
            disabled: props.disabled || props.formState.disabled || props.formState.isBusy,
            required: props.required,
            ...props.inputProps,
            onFocus: this._handleFocus,
            onBlur: this._handleBlur
        };
        const ariaDescribedBy = [];
        if (showError) {
            ariaDescribedBy.push(errorId);
            attrs["aria-invalid"] = "true";
            attrs[ERROR_FOCUS_ATTRIBUTE] = "";
        }
        if (showHelp) {
            ariaDescribedBy.push(helpId);
        }
        if (ariaDescribedBy.length > 0) {
            attrs["aria-describedby"] = ariaDescribedBy.join(" ");
        }
        return props.children({
            error: showError ? (props.error || props.backendError) : null,
            id,
            helpId,
            errorId,
            controlState: {
                value: props.value,
                onChange: this._handleChange,
                attrs
            }
        });
    }
    _handleChange(value, event) {
        const { version } = this.props.formState;
        if (value !== this.props.value && this.state.touched !== version) {
            this.setState({
                touched: version
            });
        }
        if (this.props.onChange != null) {
            this.props.onChange(value, event);
        }
    }
    _handleFocus(event) {
        if (this.props.inputProps != null && this.props.inputProps.onFocus != null) {
            this.props.inputProps.onFocus(event);
        }
        this.setState((prevState, props) => ({
            focused: true,
            // if not already showing an error, suppress any new errors until a blur occurs
            suppressErrorWhenFocused: !shouldShowError(props, prevState)
        }));
    }
    _handleBlur(event) {
        if (this.props.inputProps != null && this.props.inputProps.onBlur != null) {
            this.props.inputProps.onBlur(event);
        }
        this.setState({ focused: false });
    }
    touch() {
        this.setState({ touched: this.props.formState.version });
    }
    untouch() {
        this.setState({ touched: -1 });
    }
}
class FormGroupContainer extends Component {
    constructor() {
        super(...arguments);
        this._innerRef = createRef();
    }
    render() {
        const { props } = this;
        return (<FormSubscriber>
				{formState => (<InnerFormGroupContainer ref={this._innerRef} {...props} formState={formState}>
						{props.children}
					</InnerFormGroupContainer>)}
			</FormSubscriber>);
    }
    touch() {
        if (this._innerRef.value != null) {
            this._innerRef.value.touch();
        }
    }
    untouch() {
        if (this._innerRef.value != null) {
            this._innerRef.value.untouch();
        }
    }
}
export default FormGroupContainer;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/FormGroupContainer.tsx